/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { CrmCompanies__CrmCompanyFragmentDoc } from '../../../main-routes/crm/CrmAll.generated.js';
import { CrmCompanyListItemFragmentDoc } from '../../crm-companies/components/CrmCompanyListItem.generated.js';
import { AddressDetails__AddressFragmentDoc } from '../../addresses/Addresses.generated.js';
import { RowMember_ProjectMembershipFragmentDoc } from '../boxes/ProjectOverviewParticipantsBox.generated.js';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateProjectModal_OrganisationDefaultsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CreateProjectModal_OrganisationDefaultsQuery = { organisationDefaults: { __typename: 'OrganisationDefaults', id: string, defaultQuoteIsBinding: boolean, defaultContractType: Types.ContractType, defaultVerticalSettings: Array<{ __typename: 'OrganisationVerticalSetting', id: string, vertical: Types.Vertical, averageWorkSellingPrice: number }> } };

export type CreateProjectModal_CrmCompaniesQueryVariables = Types.Exact<{
  offset?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  limit: Types.Scalars['Int']['input'];
  sorting?: Types.InputMaybe<Array<Types.OrganisationCrmOrganisationsSorting>>;
  searchTerm?: Types.InputMaybe<Types.Scalars['String']['input']>;
  filters?: Types.InputMaybe<Types.CrmCompaniesFilters>;
}>;


export type CreateProjectModal_CrmCompaniesQuery = { crmCompanies: { __typename: 'CrmCompanyConnection', totalCount: number, edges: Array<{ __typename: 'CrmCompanyEdge', node: { __typename: 'CrmCompaniesRecord', id: string, number: string, title: string, linkedSystemOrganisationId?: string | null, abcCategory: Types.CrmOrganisationAbcCategory, systemTags: Array<string>, customTags: Array<string>, email: any, isInvited: boolean, crmDuplicateOfId?: string | null, logo?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null, contactPerson?: { __typename: 'CrmPerson', id: string, fullname: string } | null } }> } | { __typename: 'MissingPermissions' } };

export type CreateProjectModal_CrmCompanyFragment = { __typename: 'CrmCompany', id: string, title: string };

export type CrmCompany_BuildingFragment = { __typename: 'Building', id: string, title: string, createdAt: any, buildingAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null, rootItem: { __typename: 'Item', id: string, originVersionNumber?: number | null } };

export type CreateProjectModal_CrmCompanySingleQueryVariables = Types.Exact<{
  crmCompanyId: Types.Scalars['ID']['input'];
}>;


export type CreateProjectModal_CrmCompanySingleQuery = { crmCompany: { __typename: 'CrmCompanyResult', crmCompany?: { __typename: 'CrmCompany', id: string, title: string } | null } | { __typename: 'MissingPermissions' } };

export type CreateProjectModal_BuildingsQueryVariables = Types.Exact<{
  offset?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  limit: Types.Scalars['Int']['input'];
  crmCompanyId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  searchTerm?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type CreateProjectModal_BuildingsQuery = { buildings: { __typename: 'BuildingConnection', totalCount: number, edges: Array<{ __typename: 'BuildingEdge', node: { __typename: 'BuildingNode', isLinked?: boolean | null, building: { __typename: 'Building', id: string, title: string, createdAt: any, buildingAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null, rootItem: { __typename: 'Item', id: string, originVersionNumber?: number | null } } } }> } };

export type CreateProjectModal_CreateQuoteMutationVariables = Types.Exact<{
  input: Types.CreateQuoteInput;
}>;


export type CreateProjectModal_CreateQuoteMutation = { createQuote: { __typename: 'CreateQuoteResult', quote: { __typename: 'Quote', id: string }, rootItem: { __typename: 'Item', id: string, originVersionNumber?: number | null } } };

export type CreateProjectModal_CreateDocumentItemMutationVariables = Types.Exact<{
  input: Types.CreateItemsInput;
}>;


export type CreateProjectModal_CreateDocumentItemMutation = { createItems: { __typename: 'CreateItemsResult', items: Array<{ __typename: 'Item', id: string, originVersionNumber?: number | null }> } };

export type ProjectAssignToMeQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
}>;


export type ProjectAssignToMeQuery = { project: { __typename: 'MissingPermissions' } | { __typename: 'ProjectResult', project?: { __typename: 'Project', id: string, internalStakeholders: Array<{ __typename: 'ProjectMembership', id: string, user: { __typename: 'User', id: string } }>, assignee?: { __typename: 'ProjectMembership', id: string, user: { __typename: 'User', id: string, firstname: string, familyname: string, fullname: string, email: any, phones: Array<{ __typename: 'Phone', id: string, number: string }>, avatar?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null }, roles: Array<{ __typename: 'ProjectRole', id: string, internalName: string }> } | null, roles: Array<{ __typename: 'ProjectRole', id: string, internalName: string }> } | null }, organisationMemberships: { __typename: 'OrganisationMembershipsConnection', edges: Array<{ __typename: 'OrganisationMembershipEdge', node: { __typename: 'User', id: string, defaultProjectRoles: Array<{ __typename: 'ProjectRole', id: string, internalName: string }> } }> } };

export type ProjectAssignToMe_SetProjectAssigneeMutationVariables = Types.Exact<{
  membershipId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  projectId: Types.Scalars['ID']['input'];
}>;


export type ProjectAssignToMe_SetProjectAssigneeMutation = { setProjectAssignee: { __typename: 'SetProjectAssigneeResult', project: { __typename: 'Project', id: string, internalStakeholders: Array<{ __typename: 'ProjectMembership', id: string }>, assignee?: { __typename: 'ProjectMembership', id: string, user: { __typename: 'User', id: string, firstname: string, familyname: string, fullname: string, email: any, phones: Array<{ __typename: 'Phone', id: string, number: string }>, avatar?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null }, roles: Array<{ __typename: 'ProjectRole', id: string, internalName: string }> } | null } } };

export const CreateProjectModal_CrmCompanyFragmentDoc = gql`
    fragment CreateProjectModal_CrmCompany on CrmCompany {
  id
  title
}
    `;
export const CrmCompany_BuildingFragmentDoc = gql`
    fragment CrmCompany_Building on Building {
  id
  title
  buildingAddress {
    ...AddressDetails__Address
  }
  rootItem {
    id
    originVersionNumber
  }
  createdAt
}
    ${AddressDetails__AddressFragmentDoc}`;
export const CreateProjectModal_OrganisationDefaultsDocument = gql`
    query CreateProjectModal_OrganisationDefaults {
  organisationDefaults {
    ... on OrganisationDefaults {
      id
      defaultQuoteIsBinding
      defaultContractType
      defaultVerticalSettings {
        id
        vertical
        averageWorkSellingPrice
      }
    }
  }
}
    `;

/**
 * __useCreateProjectModal_OrganisationDefaultsQuery__
 *
 * To run a query within a React component, call `useCreateProjectModal_OrganisationDefaultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectModal_OrganisationDefaultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateProjectModal_OrganisationDefaultsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCreateProjectModal_OrganisationDefaultsQuery(baseOptions?: Apollo.QueryHookOptions<CreateProjectModal_OrganisationDefaultsQuery, CreateProjectModal_OrganisationDefaultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreateProjectModal_OrganisationDefaultsQuery, CreateProjectModal_OrganisationDefaultsQueryVariables>(CreateProjectModal_OrganisationDefaultsDocument, options);
      }
export function useCreateProjectModal_OrganisationDefaultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreateProjectModal_OrganisationDefaultsQuery, CreateProjectModal_OrganisationDefaultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreateProjectModal_OrganisationDefaultsQuery, CreateProjectModal_OrganisationDefaultsQueryVariables>(CreateProjectModal_OrganisationDefaultsDocument, options);
        }
export function useCreateProjectModal_OrganisationDefaultsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CreateProjectModal_OrganisationDefaultsQuery, CreateProjectModal_OrganisationDefaultsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CreateProjectModal_OrganisationDefaultsQuery, CreateProjectModal_OrganisationDefaultsQueryVariables>(CreateProjectModal_OrganisationDefaultsDocument, options);
        }
export type CreateProjectModal_OrganisationDefaultsQueryHookResult = ReturnType<typeof useCreateProjectModal_OrganisationDefaultsQuery>;
export type CreateProjectModal_OrganisationDefaultsLazyQueryHookResult = ReturnType<typeof useCreateProjectModal_OrganisationDefaultsLazyQuery>;
export type CreateProjectModal_OrganisationDefaultsSuspenseQueryHookResult = ReturnType<typeof useCreateProjectModal_OrganisationDefaultsSuspenseQuery>;
export type CreateProjectModal_OrganisationDefaultsQueryResult = Apollo.QueryResult<CreateProjectModal_OrganisationDefaultsQuery, CreateProjectModal_OrganisationDefaultsQueryVariables>;
export const CreateProjectModal_CrmCompaniesDocument = gql`
    query CreateProjectModal_CrmCompanies($offset: Int, $limit: Int!, $sorting: [OrganisationCrmOrganisationsSorting!], $searchTerm: String, $filters: CrmCompaniesFilters) {
  crmCompanies(
    offset: $offset
    limit: $limit
    sorting: $sorting
    search: $searchTerm
    filters: $filters
  ) {
    ... on CrmCompanyConnection {
      edges {
        node {
          id
          ...CrmCompanies__CrmCompany
          ...CrmCompanyListItem
        }
      }
      totalCount
    }
  }
}
    ${CrmCompanies__CrmCompanyFragmentDoc}
${CrmCompanyListItemFragmentDoc}`;

/**
 * __useCreateProjectModal_CrmCompaniesQuery__
 *
 * To run a query within a React component, call `useCreateProjectModal_CrmCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectModal_CrmCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateProjectModal_CrmCompaniesQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sorting: // value for 'sorting'
 *      searchTerm: // value for 'searchTerm'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useCreateProjectModal_CrmCompaniesQuery(baseOptions: Apollo.QueryHookOptions<CreateProjectModal_CrmCompaniesQuery, CreateProjectModal_CrmCompaniesQueryVariables> & ({ variables: CreateProjectModal_CrmCompaniesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreateProjectModal_CrmCompaniesQuery, CreateProjectModal_CrmCompaniesQueryVariables>(CreateProjectModal_CrmCompaniesDocument, options);
      }
export function useCreateProjectModal_CrmCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreateProjectModal_CrmCompaniesQuery, CreateProjectModal_CrmCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreateProjectModal_CrmCompaniesQuery, CreateProjectModal_CrmCompaniesQueryVariables>(CreateProjectModal_CrmCompaniesDocument, options);
        }
export function useCreateProjectModal_CrmCompaniesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CreateProjectModal_CrmCompaniesQuery, CreateProjectModal_CrmCompaniesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CreateProjectModal_CrmCompaniesQuery, CreateProjectModal_CrmCompaniesQueryVariables>(CreateProjectModal_CrmCompaniesDocument, options);
        }
export type CreateProjectModal_CrmCompaniesQueryHookResult = ReturnType<typeof useCreateProjectModal_CrmCompaniesQuery>;
export type CreateProjectModal_CrmCompaniesLazyQueryHookResult = ReturnType<typeof useCreateProjectModal_CrmCompaniesLazyQuery>;
export type CreateProjectModal_CrmCompaniesSuspenseQueryHookResult = ReturnType<typeof useCreateProjectModal_CrmCompaniesSuspenseQuery>;
export type CreateProjectModal_CrmCompaniesQueryResult = Apollo.QueryResult<CreateProjectModal_CrmCompaniesQuery, CreateProjectModal_CrmCompaniesQueryVariables>;
export const CreateProjectModal_CrmCompanySingleDocument = gql`
    query CreateProjectModal_CrmCompanySingle($crmCompanyId: ID!) {
  crmCompany(id: $crmCompanyId) {
    ... on CrmCompanyResult {
      crmCompany {
        ...CreateProjectModal_CrmCompany
      }
    }
  }
}
    ${CreateProjectModal_CrmCompanyFragmentDoc}`;

/**
 * __useCreateProjectModal_CrmCompanySingleQuery__
 *
 * To run a query within a React component, call `useCreateProjectModal_CrmCompanySingleQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectModal_CrmCompanySingleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateProjectModal_CrmCompanySingleQuery({
 *   variables: {
 *      crmCompanyId: // value for 'crmCompanyId'
 *   },
 * });
 */
export function useCreateProjectModal_CrmCompanySingleQuery(baseOptions: Apollo.QueryHookOptions<CreateProjectModal_CrmCompanySingleQuery, CreateProjectModal_CrmCompanySingleQueryVariables> & ({ variables: CreateProjectModal_CrmCompanySingleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreateProjectModal_CrmCompanySingleQuery, CreateProjectModal_CrmCompanySingleQueryVariables>(CreateProjectModal_CrmCompanySingleDocument, options);
      }
export function useCreateProjectModal_CrmCompanySingleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreateProjectModal_CrmCompanySingleQuery, CreateProjectModal_CrmCompanySingleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreateProjectModal_CrmCompanySingleQuery, CreateProjectModal_CrmCompanySingleQueryVariables>(CreateProjectModal_CrmCompanySingleDocument, options);
        }
export function useCreateProjectModal_CrmCompanySingleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CreateProjectModal_CrmCompanySingleQuery, CreateProjectModal_CrmCompanySingleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CreateProjectModal_CrmCompanySingleQuery, CreateProjectModal_CrmCompanySingleQueryVariables>(CreateProjectModal_CrmCompanySingleDocument, options);
        }
export type CreateProjectModal_CrmCompanySingleQueryHookResult = ReturnType<typeof useCreateProjectModal_CrmCompanySingleQuery>;
export type CreateProjectModal_CrmCompanySingleLazyQueryHookResult = ReturnType<typeof useCreateProjectModal_CrmCompanySingleLazyQuery>;
export type CreateProjectModal_CrmCompanySingleSuspenseQueryHookResult = ReturnType<typeof useCreateProjectModal_CrmCompanySingleSuspenseQuery>;
export type CreateProjectModal_CrmCompanySingleQueryResult = Apollo.QueryResult<CreateProjectModal_CrmCompanySingleQuery, CreateProjectModal_CrmCompanySingleQueryVariables>;
export const CreateProjectModal_BuildingsDocument = gql`
    query CreateProjectModal_Buildings($offset: Int, $limit: Int!, $crmCompanyId: ID, $searchTerm: String) {
  buildings(
    offset: $offset
    limit: $limit
    sorting: {hoistIfLinkedToCrmOrganisationId: $crmCompanyId}
    filters: {searchTerm: $searchTerm}
  ) {
    edges {
      node {
        building {
          id
          title
          buildingAddress {
            ...AddressDetails__Address
          }
          rootItem {
            id
            originVersionNumber
          }
          createdAt
        }
        isLinked
      }
    }
    totalCount
  }
}
    ${AddressDetails__AddressFragmentDoc}`;

/**
 * __useCreateProjectModal_BuildingsQuery__
 *
 * To run a query within a React component, call `useCreateProjectModal_BuildingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectModal_BuildingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateProjectModal_BuildingsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      crmCompanyId: // value for 'crmCompanyId'
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useCreateProjectModal_BuildingsQuery(baseOptions: Apollo.QueryHookOptions<CreateProjectModal_BuildingsQuery, CreateProjectModal_BuildingsQueryVariables> & ({ variables: CreateProjectModal_BuildingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreateProjectModal_BuildingsQuery, CreateProjectModal_BuildingsQueryVariables>(CreateProjectModal_BuildingsDocument, options);
      }
export function useCreateProjectModal_BuildingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreateProjectModal_BuildingsQuery, CreateProjectModal_BuildingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreateProjectModal_BuildingsQuery, CreateProjectModal_BuildingsQueryVariables>(CreateProjectModal_BuildingsDocument, options);
        }
export function useCreateProjectModal_BuildingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CreateProjectModal_BuildingsQuery, CreateProjectModal_BuildingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CreateProjectModal_BuildingsQuery, CreateProjectModal_BuildingsQueryVariables>(CreateProjectModal_BuildingsDocument, options);
        }
export type CreateProjectModal_BuildingsQueryHookResult = ReturnType<typeof useCreateProjectModal_BuildingsQuery>;
export type CreateProjectModal_BuildingsLazyQueryHookResult = ReturnType<typeof useCreateProjectModal_BuildingsLazyQuery>;
export type CreateProjectModal_BuildingsSuspenseQueryHookResult = ReturnType<typeof useCreateProjectModal_BuildingsSuspenseQuery>;
export type CreateProjectModal_BuildingsQueryResult = Apollo.QueryResult<CreateProjectModal_BuildingsQuery, CreateProjectModal_BuildingsQueryVariables>;
export const CreateProjectModal_CreateQuoteDocument = gql`
    mutation CreateProjectModal_CreateQuote($input: CreateQuoteInput!) {
  createQuote(input: $input) {
    quote {
      id
    }
    rootItem {
      id
      originVersionNumber
    }
  }
}
    `;
export type CreateProjectModal_CreateQuoteMutationFn = Apollo.MutationFunction<CreateProjectModal_CreateQuoteMutation, CreateProjectModal_CreateQuoteMutationVariables>;

/**
 * __useCreateProjectModal_CreateQuoteMutation__
 *
 * To run a mutation, you first call `useCreateProjectModal_CreateQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectModal_CreateQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectModalCreateQuoteMutation, { data, loading, error }] = useCreateProjectModal_CreateQuoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProjectModal_CreateQuoteMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectModal_CreateQuoteMutation, CreateProjectModal_CreateQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectModal_CreateQuoteMutation, CreateProjectModal_CreateQuoteMutationVariables>(CreateProjectModal_CreateQuoteDocument, options);
      }
export type CreateProjectModal_CreateQuoteMutationHookResult = ReturnType<typeof useCreateProjectModal_CreateQuoteMutation>;
export type CreateProjectModal_CreateQuoteMutationResult = Apollo.MutationResult<CreateProjectModal_CreateQuoteMutation>;
export type CreateProjectModal_CreateQuoteMutationOptions = Apollo.BaseMutationOptions<CreateProjectModal_CreateQuoteMutation, CreateProjectModal_CreateQuoteMutationVariables>;
export const CreateProjectModal_CreateDocumentItemDocument = gql`
    mutation CreateProjectModal_CreateDocumentItem($input: CreateItemsInput!) {
  createItems(input: $input) {
    items {
      id
      originVersionNumber
    }
  }
}
    `;
export type CreateProjectModal_CreateDocumentItemMutationFn = Apollo.MutationFunction<CreateProjectModal_CreateDocumentItemMutation, CreateProjectModal_CreateDocumentItemMutationVariables>;

/**
 * __useCreateProjectModal_CreateDocumentItemMutation__
 *
 * To run a mutation, you first call `useCreateProjectModal_CreateDocumentItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectModal_CreateDocumentItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectModalCreateDocumentItemMutation, { data, loading, error }] = useCreateProjectModal_CreateDocumentItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProjectModal_CreateDocumentItemMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectModal_CreateDocumentItemMutation, CreateProjectModal_CreateDocumentItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectModal_CreateDocumentItemMutation, CreateProjectModal_CreateDocumentItemMutationVariables>(CreateProjectModal_CreateDocumentItemDocument, options);
      }
export type CreateProjectModal_CreateDocumentItemMutationHookResult = ReturnType<typeof useCreateProjectModal_CreateDocumentItemMutation>;
export type CreateProjectModal_CreateDocumentItemMutationResult = Apollo.MutationResult<CreateProjectModal_CreateDocumentItemMutation>;
export type CreateProjectModal_CreateDocumentItemMutationOptions = Apollo.BaseMutationOptions<CreateProjectModal_CreateDocumentItemMutation, CreateProjectModal_CreateDocumentItemMutationVariables>;
export const ProjectAssignToMeDocument = gql`
    query ProjectAssignToMe($projectId: ID!) {
  project(id: $projectId) {
    ... on ProjectResult {
      project {
        id
        internalStakeholders {
          id
          user {
            id
          }
        }
        assignee {
          id
          ...RowMember_ProjectMembership
        }
        roles {
          id
          internalName
        }
      }
    }
  }
  organisationMemberships(
    offset: 0
    limit: 1000
    sorting: [{column: firstname, direction: asc}]
    filters: {statuses: [ACTIVATED]}
  ) {
    edges {
      node {
        id
        defaultProjectRoles {
          id
          internalName
        }
      }
    }
  }
}
    ${RowMember_ProjectMembershipFragmentDoc}`;

/**
 * __useProjectAssignToMeQuery__
 *
 * To run a query within a React component, call `useProjectAssignToMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectAssignToMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectAssignToMeQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectAssignToMeQuery(baseOptions: Apollo.QueryHookOptions<ProjectAssignToMeQuery, ProjectAssignToMeQueryVariables> & ({ variables: ProjectAssignToMeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectAssignToMeQuery, ProjectAssignToMeQueryVariables>(ProjectAssignToMeDocument, options);
      }
export function useProjectAssignToMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectAssignToMeQuery, ProjectAssignToMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectAssignToMeQuery, ProjectAssignToMeQueryVariables>(ProjectAssignToMeDocument, options);
        }
export function useProjectAssignToMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProjectAssignToMeQuery, ProjectAssignToMeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProjectAssignToMeQuery, ProjectAssignToMeQueryVariables>(ProjectAssignToMeDocument, options);
        }
export type ProjectAssignToMeQueryHookResult = ReturnType<typeof useProjectAssignToMeQuery>;
export type ProjectAssignToMeLazyQueryHookResult = ReturnType<typeof useProjectAssignToMeLazyQuery>;
export type ProjectAssignToMeSuspenseQueryHookResult = ReturnType<typeof useProjectAssignToMeSuspenseQuery>;
export type ProjectAssignToMeQueryResult = Apollo.QueryResult<ProjectAssignToMeQuery, ProjectAssignToMeQueryVariables>;
export const ProjectAssignToMe_SetProjectAssigneeDocument = gql`
    mutation ProjectAssignToMe_SetProjectAssignee($membershipId: ID, $projectId: ID!) {
  setProjectAssignee(membershipId: $membershipId, projectId: $projectId) {
    project {
      id
      internalStakeholders {
        id
      }
      assignee {
        id
        ...RowMember_ProjectMembership
      }
    }
  }
}
    ${RowMember_ProjectMembershipFragmentDoc}`;
export type ProjectAssignToMe_SetProjectAssigneeMutationFn = Apollo.MutationFunction<ProjectAssignToMe_SetProjectAssigneeMutation, ProjectAssignToMe_SetProjectAssigneeMutationVariables>;

/**
 * __useProjectAssignToMe_SetProjectAssigneeMutation__
 *
 * To run a mutation, you first call `useProjectAssignToMe_SetProjectAssigneeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectAssignToMe_SetProjectAssigneeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectAssignToMeSetProjectAssigneeMutation, { data, loading, error }] = useProjectAssignToMe_SetProjectAssigneeMutation({
 *   variables: {
 *      membershipId: // value for 'membershipId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectAssignToMe_SetProjectAssigneeMutation(baseOptions?: Apollo.MutationHookOptions<ProjectAssignToMe_SetProjectAssigneeMutation, ProjectAssignToMe_SetProjectAssigneeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectAssignToMe_SetProjectAssigneeMutation, ProjectAssignToMe_SetProjectAssigneeMutationVariables>(ProjectAssignToMe_SetProjectAssigneeDocument, options);
      }
export type ProjectAssignToMe_SetProjectAssigneeMutationHookResult = ReturnType<typeof useProjectAssignToMe_SetProjectAssigneeMutation>;
export type ProjectAssignToMe_SetProjectAssigneeMutationResult = Apollo.MutationResult<ProjectAssignToMe_SetProjectAssigneeMutation>;
export type ProjectAssignToMe_SetProjectAssigneeMutationOptions = Apollo.BaseMutationOptions<ProjectAssignToMe_SetProjectAssigneeMutation, ProjectAssignToMe_SetProjectAssigneeMutationVariables>;